@let componentData = componentData$ | async;
@if (componentData?.uid === 'XLink') {
  <app-footer-socialmedia-icons></app-footer-socialmedia-icons>
}

@if (componentData?.uid === 'FaceBookLink') {
  <app-footer-social-media-facebook></app-footer-social-media-facebook>
}

@if (componentData?.uid === 'InstagramLink') {
  <app-footer-social-media-instagram></app-footer-social-media-instagram>
}

@if (componentData?.uid === 'LinkedInLink') {
  <app-footer-social-media-linkedin></app-footer-social-media-linkedin>
}

@if (componentData?.uid === 'XHeaderLink') {
  <app-header-socialmedia-icons></app-header-socialmedia-icons>
}

@if (componentData?.uid === 'FaceBookHeaderLink') {
  <app-social-media-link-header-facebook>
  </app-social-media-link-header-facebook>
}

@if (componentData?.uid === 'LinkedInHeaderLink') {
  <app-social-media-link-header-instagram>
  </app-social-media-link-header-instagram>
}

@if (componentData?.uid === 'InstagramHeaderLink') {
  <app-social-media-link-header-linkedin>
  </app-social-media-link-header-linkedin>
}

@if (componentData?.uid === 'ContactUsLink') {
  <app-header-contactus></app-header-contactus>
}

@if (componentData?.uid === 'FAQHeaderLink') {
  <app-header-faq></app-header-faq>
}

@if (componentData?.uid === 'FooterContactUsLink') {
  <app-footer-contact-us></app-footer-contact-us>
}

@if (componentData?.uid === 'FaceBookCookiePolicyLink') {
  <app-cookie-policy-social></app-cookie-policy-social>
}

@if (componentData?.uid === 'FaceBooktermsofuseLink') {
  <app-terms-of-use-social-media>
  </app-terms-of-use-social-media>
}

@if (componentData?.uid === 'FaceBookPrivacyPolicyLink') {
  <app-privacy-policy-social-media>
  </app-privacy-policy-social-media>
}

@if (componentData?.uid === 'PrivacyPolicyNoticeENLink' ||
  componentData?.uid === 'PrivacyPolicyNoticeDELink' || componentData?.uid === 'PrivacyPolicyNoticeESLink' ||
  componentData?.uid === 'PrivacyPolicyNoticeBRLink' ||  componentData?.uid === 'DataSubjectRequestLink') {
  <app-privacy-policy-section3-buttons>
  </app-privacy-policy-section3-buttons>
}

@if (componentData?.uid==='HomepageNavLink' || componentData?.uid==='ProductPageNavLink') {
  <app-page-not-found-link>
  </app-page-not-found-link>
}